export default __webpack_public_path__ + "static/media/plaque3.32f2e629.jpg";